// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports
import bhr_logo from '../../images/new_logo.jpg'
import SpacerThick from './SpacerThick'

export default function BambooHRLogo() {
   const state = useQuoteContext()

   if (state.user_view == 'External') {
      return (
         <div>
            <SpacerThick />
            <div className='row'>
               <div className='col'></div>
               <div className='col'>
                  <img className='img-fluid' src={bhr_logo}></img>
               </div>
               <div className='col'></div>
            </div>
            <SpacerThick />
         </div>
      )
   }
   return null
}
